// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eYcT","colBig":"styles_colBig__6pRGk","colSmall":"styles_colSmall__2-UlD","shopifyNameWrapper":"styles_shopifyNameWrapper__3Hn02"};